import BannerPromotion from "../component/HomePage/banner";
import CategoryCard from "../component/HomePage/CategoryCard";
import Service from "../component/HomePage/Service";
import PopularGames from "../component/HomePage/PopularGames";
import { Contex } from "../component/kzContex";
import { useEffect, useContext, useState } from 'react';
import { ScrollSpy } from 'bootstrap';

const HomePage = () => {
    const { searchTerm, setSearchTerm, category, isLoading } = useContext(Contex);
    // eslint-disable-next-line no-unused-vars
    const [activeTab, setActiveTab] = useState('game');

    useEffect(() => {
        new ScrollSpy(document.body, {
          target: '#navbar-example2',
        });
      }, []);

    const filteredCategories = category.filter(c => 
        (c.type === activeTab || (!c.type && activeTab === 'game')) &&
        c.description.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (isLoading) {
        return (
            <div className="container d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
                <div className="spinner-border text-primary mb-4" role="status" style={{ width: '3rem', height: '3rem' }}>
                    <span className="visually-hidden">Loading...</span>
                </div>
                <h4 className="fw-bold mb-2">Menyiapkan Layanan...</h4>
                <p className="text-muted text-center">Server sedang bersiap untuk melayani pesananmu. <br/>Mohon tunggu sebentar ya!</p>
            </div>
        );
    }

    return(
        <div data-bs-spy="scroll" data-bs-target="#navbar-example2" data-bs-smooth-scroll="true">
            <section id="home">
                <BannerPromotion />
            </section>

            <div className="container mt-5 mb-2">
                <div className="search-wrapper position-relative mx-auto" style={{ maxWidth: '600px' }}>
                    <i className="bi bi-search position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                    <input
                        type="text"
                        className="form-control ps-5 shadow-sm py-3 border-0"
                        placeholder="Cari favoritmu..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{ borderRadius: '15px', background: 'rgba(255,255,255,0.05)', color: 'var(--textColor)' }}
                    />
                </div>
            </div>

            <PopularGames />

            {/* Menyembunyikan opsi Vouchers untuk simplifikasi penjelasan Penulisan Ilmiah */}
            {/*
            <div className="container mt-4">
                <div className="d-flex justify-content-center gap-3">
                    {['game', 'voucher'].map((tab) => (
                        <button
                            key={tab}
                            className={`btn px-4 py-2 text-capitalize ${activeTab === tab ? 'btn-primary' : 'btn-outline-secondary'}`}
                            onClick={() => setActiveTab(tab)}
                            style={{ borderRadius: '10px', fontWeight: 600 }}
                        >
                            {tab}s
                        </button>
                    ))}
                </div>
            </div>
            */}

            <section id="product" style={{ padding: '1px' }}>
                <CategoryCard categories={filteredCategories} activeTab={activeTab} />
                <Service />
            </section>

            <section id="faq" className="mt-5 mb-5 pt-5 pb-5" style={{ background: 'rgba(255,255,255,0.02)' }}>
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 className="fw-bold">Pertanyaan Umum (FAQ)</h2>
                        <p className="text-muted">Cari tahu informasi seputar layanan FamilyTopUp</p>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="accordion accordion-flush shadow-sm rounded-4 overflow-hidden" id="faqAccordion">
                                <div className="accordion-item border-0 mb-2 rounded-4 overflow-hidden">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed fw-bold py-3" type="button" data-bs-toggle="collapse" data-bs-target="#faq1">
                                            Berapa lama waktu proses top-up?
                                        </button>
                                    </h2>
                                    <div id="faq1" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                        <div className="accordion-body text-muted">
                                            Proses top-up di FamilyTopUp adalah **otomatis 24 jam**. Biasanya item akan masuk ke akun Anda dalam waktu 1-5 menit setelah pembayaran terverifikasi.
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item border-0 mb-2 rounded-4 overflow-hidden">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed fw-bold py-3" type="button" data-bs-toggle="collapse" data-bs-target="#faq2">
                                            Apa saja metode pembayaran yang tersedia?
                                        </button>
                                    </h2>
                                    <div id="faq2" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                        <div className="accordion-body text-muted">
                                            Kami mendukung berbagai metode pembayaran: QRIS (Gopay, OVO, Dana, LinkAja), Virtual Account Bank (BCA, Mandiri, BNI, BRI), serta Alfamart/Indomaret.
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item border-0 mb-2 rounded-4 overflow-hidden">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed fw-bold py-3" type="button" data-bs-toggle="collapse" data-bs-target="#faq3">
                                            Apakah top-up di sini legal?
                                        </button>
                                    </h2>
                                    <div id="faq3" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                        <div className="accordion-body text-muted">
                                            Ya, semua layanan di FamilyTopUp adalah **100% Legal dan Aman**. Kami bekerja sama dengan distributor resmi untuk memastikan akun Anda tetap aman.
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item border-0 mb-2 rounded-4 overflow-hidden">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed fw-bold py-3" type="button" data-bs-toggle="collapse" data-bs-target="#faq4">
                                            Bagaimana jika top-up belum masuk?
                                        </button>
                                    </h2>
                                    <div id="faq4" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                        <div className="accordion-body text-muted">
                                            Jika dalam 15 menit item belum masuk, harap hubungi Customer Service kami melalui tombol WhatsApp di pojok kanan bawah dengan melampirkan Nomor Pesanan atau bukti bayar.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default HomePage;